function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Slice 1");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M120.127 135.861l-16.85-51.864 44.107-32.045H92.863L76.011.09l-.005-.014h54.53l16.855 51.871v-.001l.014-.008c9.79 30.092-.292 64.318-27.278 83.923zm-88.234 0l-.014.01 44.119 32.053 44.129-32.062-44.115-32.054-44.119 32.053zM4.624 51.939c-10.304 31.721 1.657 65.333 27.26 83.928l.004-.016L48.74 83.99 4.642 51.951H59.15L76.003.089l.004-.014H21.474L4.624 51.939z",
  fill: "#EB5424",
  fillRule: "evenodd"
});

var SvgAuth0 = function SvgAuth0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 168,
    viewBox: "0 0 152 168",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuth0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auth0.967bdae8.svg";
export { ForwardRef as ReactComponent };